import { type FC } from 'react';
import { BrandedAuthPageLayoutComponent } from '~/authentication/pageWrapper/brandedAuthPageLayoutComponent';
import { RegisterFormContainer } from './form/registerForm.container';

export const RegisterPageComponent: FC = () => {
  return (
    <BrandedAuthPageLayoutComponent>
      <RegisterFormContainer />
    </BrandedAuthPageLayoutComponent>
  );
};
